<template>
  <v-app>
    <div class="login-container">
      <!-- Seção de Branding (Esquerda) -->
      <div class="branding-section">
        <div class="branding-content">
          <!-- Logo Principal -->
          <div class="main-logo">
            <img src="/apple-touch-icon.png" alt="Logo" class="app-logo" />
          </div>
          
          <!-- Título Principal -->
          <h1 class="main-title">Atualização Automática</h1>
          <p class="main-subtitle">Sistema de Gestão de Atualizações</p>
          
          <!-- Sistemas -->
          <div class="systems-grid">
            <div class="system-card">
              <img src="/ico_vcon.png" alt="VCON" class="system-icon" />
            </div>
            <div class="system-card">
              <img src="/ico_vpra.png" alt="VPRA" class="system-icon" />
            </div>
            <div class="system-card">
              <img src="/ico_vsuc.png" alt="VSUC" class="system-icon" />
            </div>
            <div class="system-card">
              <img src="/ico_vsup.png" alt="VSUP" class="system-icon" />
            </div>
            <div class="system-card">
              <img src="/ico_vsyn.png" alt="VSYN" class="system-icon" />
            </div>
          </div>
        </div>
      </div>

      <!-- Seção de Login (Direita) -->
      <div class="login-section">
        <div class="login-content">
          <h2 class="login-title">LOGIN</h2>
          
          <v-form @submit.prevent="handleLogin" class="login-form">
            <v-text-field
              v-model="username"
              label="Usuário"
              placeholder="Digite seu usuário"
              prepend-inner-icon="mdi-account"
              outlined
              required
              :disabled="loading"
              class="modern-input"
            ></v-text-field>
            
            <v-text-field
              v-model="password"
              label="Senha"
              placeholder="Digite sua senha"
              prepend-inner-icon="mdi-lock"
              type="password"
              outlined
              required
              :disabled="loading"
              class="modern-input"
            ></v-text-field>
            
            <v-btn
              type="submit"
              color="primary"
              size="large"
              block
              :loading="loading"
              :disabled="loading"
              class="login-button"
              elevation="2"
            >
              {{ loading ? 'Entrando...' : 'ENTRAR' }}
            </v-btn>
            
            <v-alert
              v-if="error"
              type="error"
              outlined
              class="mt-3"
              dismissible
              @input="error = ''"
            >
              {{ error }}
            </v-alert>
          </v-form>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import authService from '../services/authService'

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      error: ''
    }
  },
  mounted() {
    // Verificar se já está autenticado
    if (authService.isAuthenticated()) {
      console.log('🔐 Usuário já autenticado, redirecionando...')
      this.$router.push({ name: 'Dashboard' })
    }
  },
  
  methods: {
    async handleLogin() {
      console.log('🔐 Iniciando processo de login...')
      this.loading = true
      this.error = ''
      
      try {
        // Validar campos obrigatórios
        if (!this.username || !this.password) {
          this.error = 'Por favor, preencha todos os campos'
          console.log('❌ Erro: Campos obrigatórios não preenchidos')
          return
        }

        console.log('📡 Fazendo requisição de login para:', this.username)
        
        // Fazer a requisição de login usando o serviço
        const result = await authService.login(this.username, this.password)
        
        console.log('📋 Resultado do login:', result)
        
        if (result.success) {
          // Login bem-sucedido
          console.log('✅ Login realizado com sucesso:', result)
          
          // Verificar se os dados foram salvos
          const isAuth = authService.isAuthenticated()
          const token = authService.getToken()
          console.log('🔑 Status após login:', { isAuth, hasToken: !!token })
          
          // Verificar se existe um redirecionamento pendente
          let redirectUrl = localStorage.getItem('redirect_after_login')
          
          // NOVA LÓGICA: usar URL compartilhada se contiver "/dashboard?logview=" ou "filtros="
          const isValidRedirect = redirectUrl && 
            (redirectUrl.includes('/dashboard?logview=') || 
             redirectUrl.includes('filtros='));
          
          console.log('🔍 Verificando URL redirecionamento:', { 
            url: redirectUrl, 
            isValid: isValidRedirect,
            hasLogview: redirectUrl && redirectUrl.includes('/dashboard?logview='),
            hasFiltros: redirectUrl && redirectUrl.includes('filtros=')
          });
          
          if (!isValidRedirect) {
            console.log('🚫 URL salva não é válida para redirecionamento:', redirectUrl);
            console.log('🔄 Redirecionando para o Dashboard padrão');
            redirectUrl = '/dashboard';
          } else {
            console.log('✅ URL válida encontrada, preparando redirecionamento para:', redirectUrl);
          }
          
          console.log('🔀 Redirecionando para (via Vue Router):', redirectUrl);
          
          // Aguardar um tick para garantir que o DOM foi atualizado
          this.$nextTick(() => {
            // Forçar atualização do tema antes do redirecionamento
            if (this.$vuetify && this.$vuetify.theme) {
              this.$vuetify.theme.dark = this.$vuetify.theme.dark;
            }
            
            // Limpar a URL salva antes de redirecionar
            localStorage.removeItem('redirect_after_login');
            
            // Usar o Vue Router em modo hash para construir a URL correta (ex: URL/#/dashboard)
            this.$router.push(redirectUrl);
          });
        } else {
          // Erro no login
          this.error = result.message || 'Erro ao fazer login'
          console.error('❌ Erro no login:', result)
        }
      } catch (err) {
        console.error('💥 Erro inesperado no login:', err)
        this.error = 'Erro inesperado. Tente novamente.'
      } finally {
        this.loading = false
        console.log('🏁 Processo de login finalizado')
      }
    }
  }
}
</script>

<style scoped>
/* Container principal com layout de duas colunas */
.login-container {
  display: flex;
  height: 100vh;
  width: 100vw;
  background: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

/* Seção de Branding (Esquerda) */
.branding-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  position: relative;
}

.branding-content {
  text-align: center;
  max-width: 500px;
  padding: 2rem;
}

/* Logo Principal */
.main-logo {
  margin-bottom: 2rem;
}

.app-logo {
  width: 80px;
  height: 80px;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.app-logo:hover {
  transform: scale(1.05);
}

/* Título Principal */
.main-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.main-subtitle {
  color: #6c757d;
  font-size: 1.1rem;
  margin-bottom: 3rem;
  font-weight: 400;
}

/* Grid de Sistemas */
.systems-grid {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.system-card {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 2px solid rgba(25, 118, 210, 0.2);
}

.system-card:hover {
  transform: translateY(-5px) scale(1.05);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: rgba(25, 118, 210, 0.4);
}

.system-icon {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
}

/* Seção de Login (Direita) */
.login-section {
  flex: 0 0 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-left: 1px solid #e9ecef;
}

.login-content {
  width: 100%;
  max-width: 320px;
  padding: 2rem;
}

.login-title {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 2rem;
  text-align: center;
  letter-spacing: 2px;
}

.login-form {
  width: 100%;
}

.modern-input {
  margin-bottom: 1.5rem;
}

.modern-input .v-input__control .v-input__slot {
  border-radius: 12px !important;
  transition: all 0.3s ease;
  background: #ffffff !important;
  border: 2px solid #e9ecef !important;
}

.modern-input .v-input__control .v-input__slot:hover {
  border-color: #1976d2 !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.1);
}

.modern-input .v-input__control .v-input__slot:focus-within {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

.login-button {
  border-radius: 12px !important;
  height: 48px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%) !important;
  box-shadow: 0 8px 25px rgba(25, 118, 210, 0.3) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 35px rgba(25, 118, 210, 0.4) !important;
}

.login-button:active {
  transform: translateY(0);
}

/* Tema Escuro */
.theme-dark .login-container {
  background: #121212;
}

.theme-dark .branding-section {
  background: linear-gradient(135deg, #1e1e1e 0%, #2d2d2d 100%);
}

.theme-dark .main-title {
  background: linear-gradient(135deg, #64b5f6 0%, #42a5f5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.theme-dark .main-subtitle {
  color: #b0bec5;
}

.theme-dark .system-card {
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(100, 181, 246, 0.2);
}

.theme-dark .system-card:hover {
  border-color: rgba(100, 181, 246, 0.4);
}

.theme-dark .system-icon {
  border-color: rgba(255, 255, 255, 0.2);
}

.theme-dark .login-section {
  background: #121212;
  border-left: 1px solid #333333;
}

.theme-dark .login-title {
  color: #ffffff;
}

.theme-dark .modern-input .v-input__control .v-input__slot {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 2px solid rgba(255, 255, 255, 0.1) !important;
}

.theme-dark .modern-input .v-input__control .v-input__slot:hover {
  border-color: #64b5f6 !important;
  box-shadow: 0 4px 12px rgba(100, 181, 246, 0.2);
}

.theme-dark .modern-input .v-input__control .v-input__slot:focus-within {
  border-color: #64b5f6 !important;
  box-shadow: 0 0 0 3px rgba(100, 181, 246, 0.2);
}

.theme-dark .login-button {
  background: linear-gradient(135deg, #64b5f6 0%, #42a5f5 100%) !important;
  box-shadow: 0 8px 25px rgba(100, 181, 246, 0.3) !important;
}

.theme-dark .login-button:hover {
  box-shadow: 0 12px 35px rgba(100, 181, 246, 0.4) !important;
}

/* Labels dos inputs no tema escuro */
.theme-dark .modern-input .v-label {
  color: rgba(255, 255, 255, 0.8) !important;
}

.theme-dark .modern-input .v-label--active {
  color: #64b5f6 !important;
}

/* Placeholder dos inputs no tema escuro */
.theme-dark .modern-input .v-text-field__slot input::placeholder {
  color: rgba(255, 255, 255, 0.6) !important;
}

/* Texto dos inputs no tema escuro */
.theme-dark .modern-input .v-text-field__slot input {
  color: #ffffff !important;
}

/* Ícones dos inputs no tema escuro */
.theme-dark .modern-input .v-input__prepend-inner .v-icon {
  color: rgba(255, 255, 255, 0.7) !important;
}

.theme-dark .modern-input .v-input__prepend-inner .v-icon:hover {
  color: #64b5f6 !important;
}

/* Responsividade */
@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
  }
  
  .branding-section {
    flex: 0 0 40vh;
    min-height: 300px;
  }
  
  .login-section {
    flex: 1;
    border-left: none;
    border-top: 1px solid #e9ecef;
  }
  
  .theme-dark .login-section {
    border-top: 1px solid #333333;
  }
  
  .main-title {
    font-size: 2rem;
  }
  
  .systems-grid {
    gap: 1rem;
  }
  
  .system-card {
    width: 50px;
    height: 50px;
  }
  
  .system-icon {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    object-fit: cover;
  }
}

@media (max-width: 480px) {
  .branding-content {
    padding: 1rem;
  }
  
  .login-content {
    padding: 1.5rem;
  }
  
  .main-title {
    font-size: 1.8rem;
  }
  
  .main-subtitle {
    font-size: 1rem;
  }
  
  .login-title {
    font-size: 1.5rem;
  }
  
  .systems-grid {
    gap: 0.5rem;
  }
  
  .system-card {
    width: 45px;
    height: 45px;
  }
  
  .system-icon {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    object-fit: cover;
  }
}

/* Correção para autofill do Chrome */
.modern-input input:-webkit-autofill,
.modern-input input:-webkit-autofill:hover,
.modern-input input:-webkit-autofill:focus,
.modern-input input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #2d2d2d inset !important;
  -webkit-text-fill-color: #ffffff !important;
  background-color: #2d2d2d !important;
  transition: background-color 5000s ease-in-out 0s;
}

.theme-dark .modern-input input:-webkit-autofill,
.theme-dark .modern-input input:-webkit-autofill:hover,
.theme-dark .modern-input input:-webkit-autofill:focus,
.theme-dark .modern-input input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #2d2d2d inset !important;
  -webkit-text-fill-color: #ffffff !important;
  background-color: #2d2d2d !important;
  transition: background-color 5000s ease-in-out 0s;
}

/* Para tema claro */
.theme-light .modern-input input:-webkit-autofill,
.theme-light .modern-input input:-webkit-autofill:hover,
.theme-light .modern-input input:-webkit-autofill:focus,
.theme-light .modern-input input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #f5f5f5 inset !important;
  -webkit-text-fill-color: #333333 !important;
  background-color: #f5f5f5 !important;
  transition: background-color 5000s ease-in-out 0s;
}

/* Prevenir scroll global */
html, body {
  overflow: hidden;
  height: 100%;
  margin: 0;
  padding: 0;
}

/* Garantir que o app Vue não cause scroll */
#app {
  height: 100vh;
  overflow: hidden;
}

/* Animações de entrada */
@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.branding-content {
  animation: fadeInLeft 0.8s ease-out;
}

.login-content {
  animation: fadeInRight 0.8s ease-out;
}
</style> 